import { TableConfigInterface } from "@kernel/listing/table/interfaces/table-config.interface";
import { CurrencyPipe } from "@angular/common";
import { IInvoice } from "@app/shared/payment/interfaces/invoice.interfaces";

export const listInvoicesTableConfig = (currencyPipe: CurrencyPipe): TableConfigInterface => ({
  cols: [
    {
      id: "invoiceNo",
      field: "invoiceNo",
      label: "invoices.columns.invoiceNo",
      sort: "invoiceNo",
    },
    {
      id: "registeredAt",
      field: "registeredAt",
      label: "invoices.columns.registeredAt",
      sort: "registeredAt",
      format: (row: IInvoice) =>
        row.registeredAt
          ? new Date(row.registeredAt).toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })
          : "-",
    },
    {
      id: "status",
      field: "status",
      label: "invoices.columns.status",
      sort: "status",
      format: (row: IInvoice) => (row.status ? row.status.toUpperCase() : "-"),
    },
    {
      id: "totalAmount",
      field: "totalAmount",
      label: "invoices.columns.totalAmount",
      sort: "totalAmount",
      format: (row: IInvoice) => (row.totalAmount && currencyPipe.transform(row.totalAmount, row.currency, "symbol", "1.0-2")) || "-",
    },
    {
      id: "invoice-actions",
      label: "",
      actions: [
        {
          id: "view",
          icon: "viewx",
          tooltip: "invoices.actions.view",
          route: (row: IInvoice) => {
            return {
              extras: {},
              route: ["/payment/billing", { outlets: { popups: `invoices/${row.id}` } }],
            };
          },
        },
      ],
    },
  ],
  queryFields: ["id", "currency"],
  query: "listingInvoices",
});
